"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcDirection = void 0;
var RTL_LOCALES = [
    'he',
    'fa',
    'ha',
    'ar',
    'ku',
    'ur'
]; // took top 6 from here - https://meta.wikimedia.org/wiki/Template:List_of_language_names_ordered_by_code
exports.calcDirection = function (locale) {
    return RTL_LOCALES.indexOf(locale) !== -1 ? 'rtl' : 'ltr';
};
//# sourceMappingURL=calc-direction.js.map